<template>
  <ServiceInfo :data="data" />
</template>

<script>
import ServiceInfo from "../../components/serviceInfo/ServiceInfo.vue";
import { lawyerInfo } from "../../textual/info";
export default {
  components: {
    ServiceInfo,
  },
  computed: {
    data() {
      return lawyerInfo;
    },
  },
};
</script>
